import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerlessProvider } from './serverless';
import { SystemDashboardTripPointsApiRequest } from './models/system-dashboard-trip-points-api-request';
import { SystemDashboardTripPointsApiResponse } from './models/system-dashboard-trip-points-api-response';
import { SystemDashboardTripPoint } from "./models/system-dashboard-trip-point";
import { GenericItem } from './models/generic-item';
import { TimeUtil } from '../../utilities/time-util';

/**
 * [システム][ダッシュボード]トリップポイント一覧 APIの通信用プロバイダー.
 */
@Injectable()
export class SystemDashboardTripPointsServiceProvider {

  /** APIのパス */
  private readonly PATH = '/v3/system/dashboardTripPoints';

  /** 要変換プロパティ */
  private readonly CONVERSION = {
    date: [
      'startPlanDt',
      'endPlanDt',
      'initialStartPlanDt',
      'initialEndPlanDt'
    ]
  };

  constructor(public serverless: ServerlessProvider) { }

  /**
   * トリップポイント一覧を取得する.
   *
   * @param vehicleIds 車両IDの一覧
   * @param startDt 検索範囲開始日 (yyyy/MM/dd HH:mm:ss)
   * @param endDt 検索範囲終了日 (yyyy/MM/dd HH:mm:ss)
   * @param getCountNumber 取得要素数
   * @param offsetNumber オフセット番号
   * @returns トリップポイント一覧
   */
  public get(vehicleIds: number[], startDt: string, endDt: string, getCountNumber: number, offsetNumber: number): Observable<[SystemDashboardTripPoint[], boolean]> {
    const requestBody: SystemDashboardTripPointsApiRequest = { 
      vehicleIds: vehicleIds,
      startDt: startDt,
      endDt: endDt,
      getCountNumber: getCountNumber,
      offsetNumber: offsetNumber
    };

    return this.serverless.postApi<SystemDashboardTripPointsApiRequest, GenericItem<SystemDashboardTripPointsApiResponse>>
      (this.PATH, requestBody).map((responseBody) => this.toModel(responseBody));
  }

  /**
   * レスポンスボディをモデルに変換する.
   *
   * @param responseBody レスポンスボディ
   * @returns トリップポイント一覧
   */
  private toModel(responseBody: GenericItem<SystemDashboardTripPointsApiResponse>): [SystemDashboardTripPoint[], boolean] {
    const tripPoints = responseBody.item.tripPoints.map((tripPointResponse) => {
      const tripPoint = {} as SystemDashboardTripPoint;
      for (const key in tripPointResponse) {
        if (this.CONVERSION.date.indexOf(key) >= 0) {
          tripPoint[key] = TimeUtil.toDate(tripPointResponse[key]);
          continue;
        }

        tripPoint[key] = tripPointResponse[key];
      }
      return tripPoint;
    });
    return [tripPoints, responseBody.item.packageFlag];
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-dashboard-trip-points-service.ts